import { TActions } from '../../../AppModulesWrapper';

import { LOAD_PUBLISH_TERMS_SUCCESS } from '../../actions/publishTerms';
import { RESET_STATE } from '../../actions/resetState';
import { SET_TERMS_DURATION } from '../../actions/termsDurations';
import { ITermsDurationsState } from '../../types/reducers/termsDurations';

import { defaultState } from './defaultState';

export const termsDurations = (state: ITermsDurationsState = defaultState, action: TActions): ITermsDurationsState => {
  switch (action.type) {
    case LOAD_PUBLISH_TERMS_SUCCESS:
      return {
        durations: action.payload.termsDurations.durations,
        durationInDays: action.payload.termsDurations.durationInDays,
      };

    case SET_TERMS_DURATION:
      return {
        ...state,
        durationInDays: action.payload,
      };

    case RESET_STATE:
      return {
        ...defaultState,
      };

    default:
      return state;
  }
};
